/**
 * A leaf entry of the header navigation: an external link with an i18n title.
 */
export interface HeaderMenuChild {
  title: string;
  link: string;
}

/**
 * A top-level header navigation entry: either a router link
 * or a dropdown with external children.
 */
export interface HeaderMenuItem {
  title: string;
  link?: string;
  children?: HeaderMenuChild[];
}

export const HEADER_MENU: HeaderMenuItem[] = [
  {
    title: 'HEADER.MENU.PRODUCTS',
    link: '/products',
    children: [
      { title: 'HEADER.MENU.PRODUCTS_ITEM_1', link: 'https://www.imagise.app/' },
      { title: 'HEADER.MENU.PRODUCTS_ITEM_2', link: 'https://www.imagise.cloud/' },
    ],
  },
  {
    title: 'HEADER.MENU.SUPPORT',
    link: '/support',
    children: [
      {
        title: 'HEADER.MENU.SUPPORT_DOCS',
        link: 'https://docs.imagise.com/',
      },
      {
        title: 'HEADER.MENU.SUPPORT_API_REF',
        link: 'https://reference.imagise.com/',
      },
      {
        title: 'HEADER.MENU.SUPPORT_RELEASES',
        link: 'https://releases.imagise.com/',
      },
    ],
  },
  {
    title: 'HEADER.MENU.ABOUT',
    children: [
      { title: 'HEADER.MENU.ABOUT_US', link: 'https://about.imagise.com/' },
      { title: 'HEADER.MENU.ABOUT_CONTACT', link: 'https://about.imagise.com/contact' },
      { title: 'HEADER.MENU.ABOUT_LEGAL', link: 'https://about.imagise.com/legal' },
    ],
  },
];
